const CloneIcon = () => {
    return (
        <div>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Back sheet */}
                <path
                    d="M7.5 2.5H16.5C19 2.5 20.5 4 20.5 6.5V15.5"
                    stroke="#6B6B6B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                {/* Front sheet */}
                <path
                    d="M4.5 7.5H13.5C16 7.5 17.5 9 17.5 11.5V20.5C17.5 23 16 24.5 13.5 24.5H4.5C2 24.5 0.5 23 0.5 20.5V11.5C0.5 9 2 7.5 4.5 7.5Z"
                    stroke="#6B6B6B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export default CloneIcon;